export enum UserInformationRequestType {
    USERNAME = 'user_information_request_username',
    PHONE_UPDATING = 'user_information_request_phone_updating',
    ACCOUNT_VALIDATION = 'user_information_request_account_validation',
    PERSONAL_DATA = 'user_information_request_personal_data',
    DELETE_ACCOUNT = 'user_information_request_delete_account'
}
